export class ShowpadLinkHelper {
    static isShowpadLink(url) {
        return url.indexOf('showpad://') > -1;
    }
    static handleShowpadAssetLink(data) {
        const message = {};
        message.type = 'showpad-asset-link';
        message.data = {
            link: data.uri,
            target: data.target
        };
        if (window && window.postMessage) {
            window.postMessage(JSON.stringify(message), '*');
        }
    }
}
//# sourceMappingURL=ShowpadLinkHelper.js.map